import React, { useEffect, useState } from 'react'
import NavbarBottom from '../components/NavbarBottom'
import phoneIcon from '../assets/phone-call.png'


export default function Profile() {
  const [phone, setPhone] = useState(null);

  const userData = JSON.parse(localStorage.getItem('AI_UserData'))

  useEffect(() => {
    console.log(userData)
    if (userData) {
      setPhone(userData.phone)
      console.log(phone)
    }
  }, [])




  // const setCookie = (name, value, days) => {
  //   const expires = new Date(Date.now() + days * 864e5).toUTCString();
  //   document.cookie = `${name}=${value}; expires=${expires}; path=/; domain=.aiavatar.mobi; SameSite=Lax`;
  // };


  //   const handleAddCookie = (code) => {
  //     const langPath = code === "en" ? "/en/en" : `/en/${code}`;
  //     setCookie("googtrans", langPath, 7);

  //     // Force full page reload (not SPA reload)
  //     window.location.href = window.location.origin + window.location.pathname;
  //   };


  //   const handleRemoveCookie = () => {
  //     setCookie("googtrans", "/en/en", 7); // safer than removing
  //     window.location.href = window.location.origin + window.location.pathname;
  //   };




  const setAllGTranslateCookies = (langPath) => {
    const expires = new Date(Date.now() + 7 * 864e5).toUTCString();
    const cookieBase = `googtrans=${langPath}; expires=${expires}; path=/; SameSite=Lax`;

    // Set without domain
    document.cookie = cookieBase;

    // Set with current domain
    document.cookie = `${cookieBase}; domain=${window.location.hostname}`;

    // Set with base domain (e.g., .aiavatar.mobi)
    document.cookie = `${cookieBase}; domain=.aiavatar.mobi`;
  };

  const handleAddCookie = (code) => {
    const langPath = code === "en" ? "/en/en" : `/en/${code}`;
    setAllGTranslateCookies(langPath);
    window.location.href = window.location.origin + window.location.pathname;
  };

  const handleRemoveCookie = () => {
    setAllGTranslateCookies("/en/en");
    window.location.href = window.location.origin + window.location.pathname;
  };




  return (
    <>
      <div className='container pt-4 ' style={{ marginBottom: "12rem" }} >

        <h1>Profile</h1>
        <div style={{ background: '#ffffff91' }}
          className='d-flex align-items-center gap-4 mt-5 justify-content-between p-4 br_10' >
          <div className='d-flex align-items-center gap-4' >

            <img style={{ maxHeight: '30px' }} src={phoneIcon} />

            <div>
              <h1 className='p-0 m-0' >{phone}</h1>
            </div>
          </div>

        </div>


        <div style={{ background: '#ffffff91' }}
          className='d-flex flex-column align-items-center gap-4 mt-5  p-4 br_10' >

          <div className='d-flex align-items-center justify-content-between w-100 flex-wrap' >
            <h2>Languages</h2>

            {/* <div class="gtranslate_wrapper"></div> */}


            <div className='d-flex gap-2' >
              <span className='lang_span' onClick={() => handleRemoveCookie()} >English</span>
              <span className='lang_span' onClick={() => handleAddCookie("pl")} >Polish</span>
              <span className='lang_span' onClick={() => handleAddCookie("id")} >Bahasa</span>

            </div>

          </div>


          <div className='separator' ></div>

          <div className='d-flex align-items-center justify-content-between w-100 ' >
            <h2 onClick={() => window.location.href = '/Portal/privacy'}  >Privacy Policy</h2>
          </div>
          <div className='separator' ></div>

          <div className='d-flex align-items-center justify-content-between w-100 ' >
            <h2 onClick={() => window.location.href = '/Portal/terms'} >Terms And Conditions</h2>
          </div>
          <div className='separator' ></div>




        </div>
      </div>

      <NavbarBottom />
    </>
  )
}
